import Styles from './LoadingBackdrop.module.scss';
import { CircularProgress, Backdrop } from '@mui/material';
import i18n from 'i18next';

export function LoadingBackdrop({ isOpen }) {

	const loadingTextStyles = Styles[`loadingText_${i18n.language}`];

	return (
		<div id='loadingContainer' className={Styles.loadingContainer}>
			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={isOpen}>
				<div id='loadingAnimations' className={Styles.loadingAnimations}>
					<CircularProgress color="inherit" />
					<p
						id='loadingText'
						className={loadingTextStyles}
					>
					</p>
				</div>
			</Backdrop>
		</div>
	);
}
